// Photo filenames for Jeff Bosinger Memorial
const JEFF_BOSINGER_MEMORIAL = [
  'jeff-bosinger-memorial-run-6th--22_16045700797_z.jpg',
  'jeff-bosinger-memorial-run-6th--23_16229688921_z.jpg',
  'jeff-bosinger-memorial-run-6th--24_16205653456_z.jpg',
  'jeff-bosinger-memorial-run-6th--25_15609141924_z.jpg',
  'jeff-bosinger-memorial-run-6th--26_16045436369_z.jpg',
  'jeff-bosinger-memorial-run-6th--27_16044172830_z.jpg',
  'jeff-bosinger-memorial-run-6th--28_16229688731_z.jpg',
  'jeff-bosinger-memorial-run-6th--31_15609141714_z.jpg',
  'jeff-bosinger-memorial-run-6th--32_15609141654_z.jpg',
  'jeff-bosinger-memorial-run-6th--34_16044172680_z.jpg',
  'jeff-bosinger-memorial-run-6th--35_15611702803_z.jpg',
  'jeff-bosinger-memorial-run-6th--36_16044044088_z.jpg',
  'jeff-bosinger-memorial-run-6th--37_16230740972_z.jpg',
  'jeff-bosinger-memorial-run-6th--38_16230740922_z.jpg',
  'jeff-bosinger-memorial-run-6th--39_16045700237_z.jpg',
  'jeff-bosinger-memorial-run-6th--40_15611702553_z.jpg',
  'jeff-bosinger-memorial-run-6th--41_15609141324_z.jpg',
  'jeff-bosinger-memorial-run-6th--42_16044043858_z.jpg',
  'jeff-bosinger-memorial-run-6th--43_16044172280_z.jpg',
  'jeff-bosinger-memorial-run-6th--44_16230740572_z.jpg',
  'jeff-bosinger-memorial-run-6th--46_16229687941_z.jpg',
  'jeff-bosinger-memorial-run-6th--47_16229687891_z.jpg',
  'jeff-bosinger-memorial-run-6th--48_16230740442_z.jpg',
  'jeff-bosinger-memorial-run-6th--49_15611702183_z.jpg',
  'jeff-bosinger-memorial-run-6th--50_16044171910_z.jpg',
  'jeff-bosinger-memorial-run-6th--51_16044043478_z.jpg',
  'jeff-bosinger-memorial-run-6th--52_16229687741_z.jpg',
  'jeff-bosinger-memorial-run-6th--53_15609140864_z.jpg',
  'jeff-bosinger-memorial-run-6th--54_16045699597_z.jpg',
  'jeff-bosinger-memorial-run-6th--55_16231546755_z.jpg',
  'jeff-bosinger-memorial-run-6th--56_15611701823_z.jpg',
  'jeff-bosinger-memorial-run-6th--57_16229687591_z.jpg',
  'jeff-bosinger-memorial-run-6th--58_16231546615_z.jpg',
  'jeff-bosinger-memorial-run-6th--59_16045699387_z.jpg',
  'jeff-bosinger-memorial-run-6th--60_16045699317_z.jpg',
  'jeff-bosinger-memorial-run-6th--61_16230739752_z.jpg',
  'jeff-bosinger-memorial-run-6th--64_16230739772_z.jpg',
  'jeff-bosinger-memorial-run-6th--65_16229687291_z.jpg',
  'jeff-bosinger-memorial-run-6th--66_16230739582_z.jpg',
  'jeff-bosinger-memorial-run-6th--67_16045434839_z.jpg',
  'jeff-bosinger-memorial-run-6th--68_16230739482_z.jpg',
  'jeff-bosinger-memorial-run-6th--69_15611701343_z.jpg',
  'jeff-bosinger-memorial-run-6th--70_16045698897_z.jpg',
  'jeff-bosinger-memorial-run-6th--71_15611701223_z.jpg',
  'jeff-bosinger-memorial-run-6th--72_16205651726_z.jpg',
  'jeff-bosinger-memorial-run-6th--73_16044042508_z.jpg',
  'jeff-bosinger-memorial-run-6th--74_16045434499_z.jpg',
  'jeff-bosinger-memorial-run-6th--75_16045434449_z.jpg',
  'jeff-bosinger-memorial-run-6th--76_16045434349_z.jpg',
  'jeff-bosinger-memorial-run-6th--77_15611700943_z.jpg',
  'jeff-bosinger-memorial-run-6th--78_16230739102_z.jpg',
  'jeff-bosinger-memorial-run-6th--79_16231545925_z.jpg',
  'jeff-bosinger-memorial-run-6th--81_16230739032_z.jpg',
  'jeff-bosinger-memorial-run-6th--85_16231545815_z.jpg',
  'jeff-bosinger-memorial-run-6th--86_16231545785_z.jpg',
  'jeff-bosinger-memorial-run-6th--87_16045434049_z.jpg',
  'jeff-bosinger-memorial-run-6th--88_16045698297_z.jpg',
  'jeff-bosinger-memorial-run-6th--89_16230738832_z.jpg',
  'jeff-bosinger-memorial-run-6th--90_16044041888_z.jpg',
  'jeff-bosinger-memorial-run-6th--91_16229686131_z.jpg',
  'jeff-bosinger-memorial-run-6th--92_16229686071_z.jpg',
  'jeff-bosinger-memorial-run-6th--93_16044170160_z.jpg',
  'jeff-bosinger-memorial-run-6th--94_15611700293_z.jpg',
  'jeff-bosinger-memorial-run-6th--95_16044041688_z.jpg',
  'jeff-bosinger-memorial-run-6th--96_16205650856_z.jpg',
  'jeff-bosinger-memorial-run-6th--97_16229685781_z.jpg',
  'jeff-bosinger-memorial-run-6th--98_15611700083_z.jpg',
  'jeff-bosinger-memorial-run-6th--99_15611700043_z.jpg',
  'jeff-bosinger-memorial-run-6th--100_15609139144_z.jpg',
  'jeff-bosinger-memorial-run-6th--101_16205650626_z.jpg',
  'jeff-bosinger-memorial-run-6th--102_16229685541_z.jpg',
  'jeff-bosinger-memorial-run-6th--103_16230738072_z.jpg',
  'jeff-bosinger-memorial-run-6th--105_16229685481_z.jpg',
  'jeff-bosinger-memorial-run-6th--106_16044041238_z.jpg',
  'jeff-bosinger-memorial-run-6th--107_16231544845_z.jpg',
  'jeff-bosinger-memorial-run-6th--108_16205650486_z.jpg',
  'jeff-bosinger-memorial-run-6th--109_16231544725_z.jpg',
  'jeff-bosinger-memorial-run-6th--112_16229685171_z.jpg',
  'jeff-bosinger-memorial-run-6th--113_16045697177_z.jpg',
  'jeff-bosinger-memorial-run-6th--5_16229689251_z.jpg',
  'jeff-bosinger-memorial-run-6th--10_15611703493_z.jpg',
  'jeff-bosinger-memorial-run-6th--12_16045436679_z.jpg',
  'jeff-bosinger-memorial-run-6th--19_16205653716_z.jpg',
  'jeff-bosinger-memorial-run-6th--21_16044044698_z.jpg',
];

export default JEFF_BOSINGER_MEMORIAL;
